<template>
  <global-layout>
    <banner></banner>
    <!-- <app-scene></app-scene> -->
    <process></process>
    <one-key-access></one-key-access>
    <multi-scenario-solution></multi-scenario-solution>
  </global-layout>
</template>

<script>
  import Banner from './components/banner-swiper';
  import AppScene from './components/app-scene';
  import process from './components/process';
  import multiScenarioSolution from './components/multi-scenario-solution';
  import oneKeyAccess from './components/one-key-access';

  export default {
    components: {
      Banner,
      AppScene,
      process,
      multiScenarioSolution,
      oneKeyAccess,
    },
  };
</script>


